import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import {

} from 'react-router-dom';
import { compose } from 'redux';
import {
  LayoutWrapperMain, ManageVersion, Page,
} from '../../components';
import config from '../../config';
import './manageversion.global.scss';

interface Props {
  scrollingDisabled: boolean,
  intl: any,
}

const ManageVersionComponent: React.FC<Props> = (props: Props) => {
  const {
    intl,
    scrollingDisabled,
  } = props;
  const { siteTitle } = config;
  const schemaTitle = intl.formatMessage(
    { id: 'VersionManagement.Page.title' },
    { siteTitle },
  );
  return (
    <Page
      title={schemaTitle}
      scrollingDisabled={scrollingDisabled}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        name: schemaTitle,
      }}
    >
      <LayoutWrapperMain className="layoutWrapperMain">
        <div className="content">
          <ManageVersion />
        </div>
      </LayoutWrapperMain>
    </Page>
  );
};

const mapStateToProps = () => ({
});

const mapDispatchToProps = () => ({
});

const ManageVersionComponentPage = compose(

  connect(mapStateToProps, mapDispatchToProps),
  injectIntl,
)(ManageVersionComponent);

export default ManageVersionComponentPage;
